import { Theme } from '../Theme'
import { LOGO_NAMES, THEMED_LOGO_NAMES } from './logos/constants'
import { LogoNames, ThemedLogoNames } from '.'
import { Country } from '@afterpay/types'

type ThemedLogoComponentName = Record<Theme, LogoNames | ThemedLogoNames>

export const mapBronteToThemedLogo: Record<LogoNames | ThemedLogoNames, ThemedLogoComponentName> = {
  [LOGO_NAMES.AFTERPAY]: {
    [Theme.AP]: LOGO_NAMES.AFTERPAY,
    [Theme.Cash]: THEMED_LOGO_NAMES.CASHAPP_AFTERPAY,
    [Theme.Pegasus]: THEMED_LOGO_NAMES.CASHAPP_AFTERPAY,
    [Theme.Kelpie]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL,
  },
  [LOGO_NAMES.CLEARPAY]: {
    [Theme.AP]: LOGO_NAMES.CLEARPAY,
    [Theme.Cash]: LOGO_NAMES.CLEARPAY,
    [Theme.Pegasus]: LOGO_NAMES.CLEARPAY,
    [Theme.Kelpie]: LOGO_NAMES.CLEARPAY,
  },
  [THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL]: {
    [Theme.AP]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL,
    [Theme.Cash]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL,
    [Theme.Pegasus]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL,
    [Theme.Kelpie]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL,
  },
  [THEMED_LOGO_NAMES.CASHAPP_AFTERPAY]: {
    [Theme.AP]: THEMED_LOGO_NAMES.CASHAPP_AFTERPAY,
    [Theme.Cash]: THEMED_LOGO_NAMES.CASHAPP_AFTERPAY,
    [Theme.Pegasus]: THEMED_LOGO_NAMES.CASHAPP_AFTERPAY,
    [Theme.Kelpie]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL,
  },
  [THEMED_LOGO_NAMES.ARCADE_AFTERPAY]: {
    [Theme.AP]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY,
    [Theme.Cash]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY,
    [Theme.Pegasus]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY,
    [Theme.Kelpie]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL,
  },
}

export const getLogoByThemeAndCountry = (logoName: LogoNames | ThemedLogoNames, theme: Theme, country?: Country): LogoNames | ThemedLogoNames => {
  const isArcadeTheme = theme === Theme.Cash || theme === Theme.Pegasus || theme === Theme.Kelpie

  if (isArcadeTheme && country) {
    const arcadeAfterpayLogos: Partial<Record<Country, LogoNames | ThemedLogoNames>> = {
      [Country.US]: THEMED_LOGO_NAMES.CASHAPP_AFTERPAY,
      [Country.AU]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL,
    }

    if (logoName === LOGO_NAMES.AFTERPAY) {
      return arcadeAfterpayLogos[country] ?? LOGO_NAMES.AFTERPAY
    }
    if (logoName === LOGO_NAMES.CLEARPAY) {
      return LOGO_NAMES.CLEARPAY
    }
  }

  return mapBronteToThemedLogo[logoName]?.[theme] || logoName
}

export const mapThemedLogoViewBox: Record<LogoNames | ThemedLogoNames, string> = {
  [LOGO_NAMES.AFTERPAY]: '0 0 108 20',
  [LOGO_NAMES.CLEARPAY]: '0 0 108 20',
  [THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL]: '0 0 95 32',
  [THEMED_LOGO_NAMES.CASHAPP_AFTERPAY]: '0 0 98 24',
  [THEMED_LOGO_NAMES.ARCADE_AFTERPAY]: '0 0 98 24',
}
